import styled from "styled-components";

export const BodyContainer = styled.div`
  & > * + * {
    margin-top: 2rem;
  }
`;

export const ColumnsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  & > * + * {
    margin-left: 1rem;
  }
`;

export const ButtonsColumn = styled.div`
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: 1rem;
  }
  padding-left: 2rem;
  padding-right: 2rem;
  align-items: center;
  justify-content: center;
`;

export const InlineButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: flex-end;
  justify-content: space-between;
`;

export const ButtonsBloc = styled.div`
  display: flex;
  margin-top: 0.5em;
  & > * + * {
    margin-left: 0.5em;
  }
`;
